export const formatSignatureForPreview = (signature: string): string =>
  signature.replace(/\s|\//g, "-");
